import { useEffect, useState } from 'react'
import { Plus } from 'lucide-react'
import { Link } from 'react-router-dom'
import * as styled from '../../../../util/styled'
import { Tooltip } from '../../../../design-system/Tooltip/Tooltip'

const Wrapper = styled.component(Link)<{ active: boolean }>((props) => ({
  'border-2 border-border-standby group hover:border-brand rounded-xl block cursor-pointer transition-colors': true,
  'border-brand shadow': props.active,
}))
const logoCommon = 'w-10 h-10 rounded-lg m-1'
const Logo = styled.img(logoCommon)
const TitleLogo = styled.div('flex flex-col justify-center items-center bg-brand-bg text-surface-elevated ' + logoCommon)
const AddBrandButton = styled.div(logoCommon + ' text-text-tertiary flex items-center justify-center group-hover:bg-surface-darker')

type BrandNameBarProps = {
  title: string
  active: boolean
  url: string | undefined | null
  href: string
}

export const BrandNameBox = (props: BrandNameBarProps) => {
  const { title, url, active, href } = props
const [logoUrl, setLogoUrl] = useState<string | null>(null) 
  useEffect(() => {
    if (url) {
      const suffixes = ['.ico', '.png', '.svg', '.webp']

      for (const suffix of suffixes) {
        const img = new Image()
        img.src = `${url}/favicon${suffix}`
        img.onload = () => setLogoUrl((existing) => existing ?? `${url}/favicon${suffix}`)
      }
      
      const img = new Image()
      img.src = url
      img.onload = () => setLogoUrl(url)
    }
  }, [url])
  return (
    <Tooltip content={title}>
      <Wrapper to={href} active={active}>
          {logoUrl && <Logo src={logoUrl} />}
          {!logoUrl && <TitleLogo>{title[0].toLocaleUpperCase()}</TitleLogo>}
      </Wrapper>
    </Tooltip>
  )
}

type AddBrandButtonViewProps = {
  href: string
}

export const AddBrandButtonView = (props: AddBrandButtonViewProps) => {
  return (
    <Tooltip content={'Add new brand'}>
      <Wrapper to={props.href} active={false}>
        <AddBrandButton>
          <Plus />
        </AddBrandButton>
      </Wrapper>
    </Tooltip>
  )
}